// extracted by mini-css-extract-plugin
module.exports = {"accountsList":"WSAccountsList_accountsList__2P8VK","account":"WSAccountsList_account__1erEI","accountsGroupHeader":"WSAccountsList_accountsGroupHeader__yBYLR"};